module.exports = __webpack_public_path__ + "static/media/baja-y-desguace-de-vehiculos.34f24d52.png";